import { LOCALE_KEY } from '@fx-ui/intl';

export enum VALID_STEP { // 操作步骤
    EXIT = 'exit', // 退出企业时的身份验证
    BIND = 'bind', // 绑定1
    BIND2 = 'bind2', // 绑定2
    UNBIND = 'unbind', // 解绑1
    VERIFY = 'verify', // 验证1
    VERIFY2 = 'verify2', // 验证2，没有密码但是绑定了手机号或者邮箱，在设置密码时需先验证手机号或邮箱
    MODIFY = 'modify', // 换绑1
    MODIFY2 = 'modify2', // 换绑2
    MFA = 'mfa' // 多因素验证
}

export enum VALID_TYPE { // 当前校验的验证类型
    PWD = 'pwd', // 密码
    EMAIL = 'email', // 邮箱
    PHONE = 'phone' // 手机号
}

export enum VERIFY_MODE { // 操作类型
    EMAIL = 'email',
    PHONE = 'phone'
}

/**
 * 画像信息
 */
export interface PersonaInfo {
    tenantId?: string;
    suiteId?: number;
    corpName?: string;
    companyDetail?: {
        name: string;
    };
    requirement?: { value: string; text: string };
    industry?: { value: string; text: string };
    favorites?: string[];
    suiteCustomData?: Record<string, string | string[]>;
    nickname?: string;
    phone?: string;
    role?: { value: string; text: string };
    referrers?: string[];
    refererOtherVal?: string;
    hasChosenIndustry?: boolean;
    hasCollectedCorpInfo?: boolean;
    hasChosenDemand?: boolean;
    hasChosenRole?: boolean;
}

export interface PersonaCustomComponent {
    key: string;
    enabled?: boolean;
    type: 'combo' | 'combo-check';
    scope: 'tenant' | 'user';
    label: Partial<Record<LOCALE_KEY, string>>;
    placeholder?: Partial<Record<LOCALE_KEY, string>>;
    options?: {
        value: string;
        label: Partial<Record<LOCALE_KEY, string>>;
    }[];
}

export interface PersonaLabel {
    custom_components?: PersonaCustomComponent[];
    /** 所属行业 */
    industries?: Record<string, string[]>;
    /**
     * 管理需求单独配置的选项列表
     *
     * 有值时：管理需求独立配置，与所属行业无关
     * 无值时：与所属行业联动，选项取自 industries[industry]
     */
    favorites?: string[];
    referrers?: string[];
    jobs?: string[];
    requirement?: string[];
    show_phone?: boolean;
}

export interface InvitationInfo {
    corpId?: string;
    corpName?: string;
    memberId?: string;
    inviterId?: string;
    inviterName?: string;
}

/** 认证状态枚举 */
export enum TENANT_VERIFY_STATUS {
    /** 未认证 */
    UNVERIFIED = 'unverified',
    /** 认证审核中 */
    OPEN = 'open',
    /** 认证已通过 */
    APPROVED = 'approved',
    /** 认证已过期 */
    EXPIRED = 'expired'
}

/**
 * 接口 获取企业认证信息, 可选触发继承第三方认证
 * @请求头 `POST /arch/tenant/verify/profile`
 */
export interface CorpVerifyProfile {
    /**
     * 个人认证信息
     */
    owner: {
        _id: string;
        status: TENANT_VERIFY_STATUS;
        expire_time?: string;
    };
    /**
     * 企业认证信息
     */
    corp: {
        _id: string;
        status: TENANT_VERIFY_STATUS;
        expire_time?: string;
    };
    /**
     * 是否触发了继承效果
     */
    is_trigger_inherit: boolean;
}

/**
 * 通讯录成员邀请引导 - 标记位
 */
export enum MEMBER_INVITE_FLAG {
    /** 显示引导 */
    NEED = 'need',
    /** 不显示引导 */
    DONE = 'done'
}
